module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/zh-hant-card-drag.53fc4eebdf0af23fb427.gif";